<template>
    <div class="transfer-result">
        <div class="text-center mt-4">
            <div class="font-15">{{ pageTitle }}</div>
        </div>

        <ConvertHeader class="pt-9" mode="point" :showTitle="false" :showCurrentPoint="true" :userProfile="userProfile"
            ref="convertHeader" :blobConfig="blobConfig" :pointRaw="userPointsRaw" :pointConverted="userConvertPoint"
            :lbl="lbl" :toApp="toApp"></ConvertHeader>

        <div class="buttons px-4">
            <PrimaryButton @click="onClickBack">
                {{ lbl.buttons.backToHome }}
            </PrimaryButton>
        </div>
    </div>
</template>
<script>
import PrimaryButton from "../Button/PrimaryButton.vue";
import ConvertHeader from "../../component/Header/ConvertHeader.vue";

export default {
    name: "TransferResult",
    props: {
        lbl: {
            type: Object,
        },
        userProfile: {
            type: Object,
        },
    },
    components: {
        PrimaryButton,
        ConvertHeader,
    },
    inject: ["LandingStates", "TransferPointStates", "AccountStore"],
    emits: ["onClickBack"],
    computed: {
        toApp: function () {
            return this.lbl?.module?.exchange_name ?? "";
        },
        pageTitle: function () {
            return this.lbl.result.successfully
        },
        blobConfig: function () {
            return this.LandingStates.appConfig
        },
        userPointsRaw: function () {
            return this.LandingStates.selectTier?.Points ?? 0
        },
        userConvertPoint: function () {
            return this.LandingStates.selectTier?.Partner ?? 0
        },
    },
    methods: {
        onClickBack: function () {
            this.$emit("onClickBack")
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../style/base.scss";

.transfer-result {
    @extend %base-class;

    color: $gray;
    padding: 0px 16px 36px;

    .buttons {
        margin-top: 64px;
    }
}

.pt-36px {
    padding-top: 36px;
}
</style>
